export type EventStatus = 'planned' | 'active' | 'completed' | 'archived';
export type EventType = 'Conference' | 'Trade Show' | 'Expo' | 'Summit' | 'Forum' | 'Exhibition';
export type EventPriority = 'High' | 'Medium' | 'Low';

export interface EventRecord {
  id: string;
  name: string;
  type: EventType;
  venue: string;
  city: string;
  country: string;
  startDate: string;
  endDate: string;
  website: string;
  description: string;
  priority: EventPriority;
  status: EventStatus;
  goals: string;
  notes: string;
  // Pipeline stats
  totalContacts: number;
  highPriority: number;
  linkedinConnected: number;
  meetingRequests: number;
  meetingsConfirmed: number;
  meetingsCompleted: number;
  followUpPending: number;
  opportunities: number;
  // Computed
  daysUntil: number;
}

// Backend integration point: replace with API call GET /api/events
export const mockEvents: EventRecord[] = [
  {
    id: 'event-001',
    name: 'NRA Show 2026',
    type: 'Trade Show',
    venue: 'McCormick Place',
    city: 'Chicago',
    country: 'USA',
    startDate: '2026-05-17',
    endDate: '2026-05-20',
    website: 'https://show.restaurant.org',
    description: 'The world\'s largest foodservice trade show. Key target for food distribution and restaurant supply relationships.',
    priority: 'High',
    status: 'active',
    goals: 'Confirm 10 meetings, connect with 50 procurement decision-makers, identify 5 partnership opportunities.',
    notes: 'Booth 4421 confirmed. Pre-event reception on May 16.',
    totalContacts: 247,
    highPriority: 48,
    linkedinConnected: 83,
    meetingRequests: 28,
    meetingsConfirmed: 18,
    meetingsCompleted: 0,
    followUpPending: 34,
    opportunities: 6,
    daysUntil: 18,
  },
  {
    id: 'event-002',
    name: 'FOODEX Japan 2026',
    type: 'Exhibition',
    venue: 'Makuhari Messe',
    city: 'Chiba',
    country: 'Japan',
    startDate: '2026-05-13',
    endDate: '2026-05-16',
    website: 'https://www.jma.or.jp/foodex',
    description: 'Asia\'s largest food and beverage trade show. Focus on Asian distribution partnerships and retail expansion.',
    priority: 'High',
    status: 'planned',
    goals: 'Identify 20 regional distributor contacts, schedule 5 meetings with Japanese retail buyers.',
    notes: 'Need Japanese-language intro materials. Consider local partner presence.',
    totalContacts: 64,
    highPriority: 12,
    linkedinConnected: 14,
    meetingRequests: 4,
    meetingsConfirmed: 2,
    meetingsCompleted: 0,
    followUpPending: 0,
    opportunities: 0,
    daysUntil: 54,
  },
  {
    id: 'event-003',
    name: 'Anuga 2026',
    type: 'Trade Show',
    venue: 'Koelnmesse',
    city: 'Cologne',
    country: 'Germany',
    startDate: '2026-10-03',
    endDate: '2026-10-07',
    website: 'https://www.anuga.com',
    description: 'World\'s leading food and beverage trade fair. Target European retail and wholesale buyers.',
    priority: 'Medium',
    status: 'planned',
    goals: 'Build European pipeline, identify 30 potential partners in EU retail.',
    notes: 'Early planning phase. Booth application submitted.',
    totalContacts: 38,
    highPriority: 8,
    linkedinConnected: 6,
    meetingRequests: 1,
    meetingsConfirmed: 0,
    meetingsCompleted: 0,
    followUpPending: 0,
    opportunities: 0,
    daysUntil: 198,
  },
  {
    id: 'event-004',
    name: 'Restaurant & Bar HK 2025',
    type: 'Exhibition',
    venue: 'Hong Kong Convention Centre',
    city: 'Hong Kong',
    country: 'China',
    startDate: '2025-11-05',
    endDate: '2025-11-08',
    website: 'https://www.restaurantbar.hk',
    description: 'Asia Pacific hospitality and foodservice event. Strong focus on restaurant tech and supply.',
    priority: 'Medium',
    status: 'completed',
    goals: 'Meet 8 regional distributors, qualify 4 leads for follow-up.',
    notes: 'Completed. 3 active opportunities from this event.',
    totalContacts: 89,
    highPriority: 22,
    linkedinConnected: 54,
    meetingRequests: 14,
    meetingsConfirmed: 11,
    meetingsCompleted: 11,
    followUpPending: 3,
    opportunities: 3,
    daysUntil: -135,
  },
  {
    id: 'event-005',
    name: 'Food & Hotel Asia 2025',
    type: 'Conference',
    venue: 'Sands Expo',
    city: 'Singapore',
    country: 'Singapore',
    startDate: '2025-09-22',
    endDate: '2025-09-25',
    website: 'https://www.fhahoreca.com',
    description: 'Leading ASEAN hospitality trade event. Targeted for SE Asian expansion strategy.',
    priority: 'Low',
    status: 'completed',
    goals: 'Initial market reconnaissance. Identify 10 SE Asian prospects.',
    notes: 'Good event. Two contacts now in active pipeline.',
    totalContacts: 43,
    highPriority: 9,
    linkedinConnected: 28,
    meetingRequests: 8,
    meetingsConfirmed: 6,
    meetingsCompleted: 6,
    followUpPending: 0,
    opportunities: 2,
    daysUntil: -182,
  },
  {
    id: 'event-006',
    name: 'Gulfood Manufacturing 2026',
    type: 'Summit',
    venue: 'Dubai World Trade Centre',
    city: 'Dubai',
    country: 'UAE',
    startDate: '2026-11-03',
    endDate: '2026-11-05',
    website: 'https://www.gulfoodmanufacturing.com',
    description: 'Middle East\'s leading food ingredient and technology event. Target GCC food manufacturers.',
    priority: 'Medium',
    status: 'planned',
    goals: 'Build GCC pipeline, identify 15 ingredient sourcing contacts.',
    notes: 'Early planning. Visa requirements for UAE.',
    totalContacts: 12,
    highPriority: 3,
    linkedinConnected: 2,
    meetingRequests: 0,
    meetingsConfirmed: 0,
    meetingsCompleted: 0,
    followUpPending: 0,
    opportunities: 0,
    daysUntil: 225,
  },
];